import React from 'react';

function usePagination() {
  const [page, setPage] = React.useState(0);

  const handlePageChange = React.useCallback(page => {
    setPage(page);
  }, []);

  return { page, handlePageChange };
}

export default usePagination;
